// Periods-Step (Zeiträume) – Clubmeisterschaft: Gesamtzeitraum, Gruppenphase, K.-o.-Phase (ohne Uhrzeit)

import React from "react";

/**
 * Props:
 * t
 * mode: "groupsKo" | ...
 * periods: { overall:{startDate,endDate}, groups:{...}, ko:{...} }
 * setPeriods: (next) => void
 */
export function PeriodsStep({ t, mode, periods, setPeriods }) {
  const p = periods || {};
  const set = (path, value) => {
    const [scope, key] = path.split(".");
    setPeriods({
      ...p,
      [scope]: { ...(p[scope] || {}), [key]: value },
    });
  };
  const translate = t || (key => key);

  return (
    <div className="tm-wizard-periods-step">
      <div className="tm-wizard-card tm-wizard-card--mb">
        <h3 className="tm-wizard-section-title">{translate("club.periods.overall.title")}</h3>
        <div className="tm-wizard-points-row">
          <label className="tm-wizard-field tm-wizard-field--full">
            <span className="tm-wizard-field__label">{translate("club.periods.start")}</span>
            <input
              className="tm-wizard-field__input"
              type="date"
              value={p.overall?.startDate || ""}
              onChange={(e) => set("overall.startDate", e.target.value)}
            />
          </label>
          <label className="tm-wizard-field tm-wizard-field--full">
            <span className="tm-wizard-field__label">{translate("club.periods.end")}</span>
            <input
              className="tm-wizard-field__input"
              type="date"
              value={p.overall?.endDate || ""}
              onChange={(e) => set("overall.endDate", e.target.value)}
            />
          </label>
        </div>
      </div>

      {mode === "groupsKo" ? (
        <>
          <div className="tm-wizard-card tm-wizard-card--mb">
            <h3 className="tm-wizard-section-title">{translate("club.periods.groups.title")}</h3>
            <div className="tm-wizard-points-row">
              <label className="tm-wizard-field tm-wizard-field--full">
                <span className="tm-wizard-field__label">{translate("club.periods.start")}</span>
                <input
                  className="tm-wizard-field__input"
                  type="date"
                  value={p.groups?.startDate || ""}
                  onChange={(e) => set("groups.startDate", e.target.value)}
                />
              </label>
              <label className="tm-wizard-field tm-wizard-field--full">
                <span className="tm-wizard-field__label">{translate("club.periods.end")}</span>
                <input
                  className="tm-wizard-field__input"
                  type="date"
                  value={p.groups?.endDate || ""}
                  onChange={(e) => set("groups.endDate", e.target.value)}
                />
              </label>
            </div>
          </div>

          <div className="tm-wizard-card tm-wizard-card--mb">
            <h3 className="tm-wizard-section-title">{translate("club.periods.ko.title")}</h3>
            <div className="tm-wizard-points-row">
              <label className="tm-wizard-field tm-wizard-field--full">
                <span className="tm-wizard-field__label">{translate("club.periods.start")}</span>
                <input
                  className="tm-wizard-field__input"
                  type="date"
                  value={p.ko?.startDate || ""}
                  onChange={(e) => set("ko.startDate", e.target.value)}
                />
              </label>
              <label className="tm-wizard-field tm-wizard-field--full">
                <span className="tm-wizard-field__label">{translate("club.periods.end")}</span>
                <input
                  className="tm-wizard-field__input"
                  type="date"
                  value={p.ko?.endDate || ""}
                  onChange={(e) => set("ko.endDate", e.target.value)}
                />
              </label>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
}
